"use strict";
/**
* Copyright: Microsoft 2016
*/
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var localizer_1 = require("../localizer");
exports.localizer = localizer_1.localizer;
__export(require("../loader/localizationProvider"));
var translate_1 = require("../translate");
exports.Translate = translate_1.Translate;
